import { render } from "./ModalContentDummy.vue?vue&type=template&id=ddb48ac4&lang=true"
const script = {}
script.render = render

export default script